// extracted by mini-css-extract-plugin
export var carrierNotice = "_ki-5";
export var carrierNoticePlaceholder = "_ki-6";
export var deliveryRow = "_ki-c";
export var fixedHeight = "_ki-4";
export var freightLogo = "_ki-b";
export var fullWidth = "_ki-3";
export var priceColumn = "_ki-7";
export var radioSelected = "_ki-9";
export var radioUnselected = "_ki-8";
export var selectedOption = "_ki-2";
export var selectedOptionContainer = "_ki-1";
export var selection = "_ki-0";
export var tallSkeletonText = "_ki-a";